module.exports = __webpack_public_path__ + "media/images/new/result/success-f14d72dcce895d0d53e00a5a7eb2ce75.png";